const stats = [
  { num: "5000+", label: "精选视频资源" },
  { num: "30+", label: "内容栏目" },
  { num: "800万+", label: "累计播放量" },
  { num: "6", label: "吃瓜内容分类" },
];

const testimonials = [
  {
    name: "小瓜同学",
    role: "娱乐八卦爱好者",
    text: "内容更新真的很快，热门刚出就能看到，而且播放很流畅，点开就能看不用等，追更体验一级棒。",
  },
  {
    name: "阿白",
    role: "下班通勤党",
    text: "手机上看特别方便，路上刷几个萌宠视频心情瞬间变好，分类也很清楚，一下就能找到想看的。",
  },
  {
    name: "豆豆",
    role: "吃瓜老玩家",
    text: "从娱乐到社会热点都有，质量很稳，界面看着舒服不花哨，我已经把它设成每天必刷的站点。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div>
            <p className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-information-line"></i>
              关于我们
            </p>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
              一个懂你、够快、有趣的吃瓜视频网站
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              吃瓜视频在线专注聚合当下最热门的娱乐八卦、社会热点与生活趣事视频。我们坚持"即点即看、无需安装、高清流畅"的内容体验，把分散各处的吃瓜内容整合到一个地方，让你不用在多家站点之间来回切换，一站就能找到想看的内容。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              我们始终坚持真实、及时、多元的内容原则，尊重原创与版权，只收录合规内容，用稳定的播放体验和贴心的分类导航，陪伴每一位热爱吃瓜的你。
            </p>

            <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-lg bg-background-50 p-4 text-center ring-1 ring-background-200">
                  <p className="font-heading text-2xl text-primary-600">{s.num}</p>
                  <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="font-heading text-lg text-foreground-950 md:text-xl">吃瓜网友的口碑</h3>
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-lg bg-background-50 p-5 ring-1 ring-background-200">
                <div className="flex items-center gap-1 text-accent-600">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <blockquote className="mt-3 text-sm text-foreground-700">
                  "{t.text}"
                </blockquote>
                <figcaption className="mt-3 flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                    <i className="ri-user-line"></i>
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-950">{t.name}</span>
                    <span className="block text-xs text-foreground-600">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}